import styled from 'styled-components'
import { Divider } from 'antd'

export const CharacterName = styled.h1`
  font-size: 64px;
  font-family: MidnightMoon;
  font-weight: normal;
`

export const CharacterConcept = styled.h3`
  font-size: 36px;
  margin: -16px;
  color: darkred;
  font-family: HonestMaria;
`

export const SectionTitle = styled.h2`
  font-size: 56px;
  margin: 0 0 24px;
  font-family: MidnightMoon;
  font-weight: normal;
`

export const EmptyDivider = styled(Divider)`
  font-family: HonestMaria;

  > span {
    font-size: 28px;
    color: darkred;
  }
`
